// API Configuration
const API_CONFIG = {
  BASE_URL: 'https://cvsortingapi.scibd.info',
  ENDPOINTS: {
    // Auth endpoints
    ADMIN_LOGIN: '/admin/api/auth/admin/login',
    ADMIN_REFRESH: '/admin/api/auth/refresh',
    ADMIN_LOGOUT: '/admin/api/auth/logout',
    USER_LOGIN: '/admin/api/auth/user/login',
    USER_REFRESH: '/admin/api/auth/refresh/user',
    
    // User management endpoints
    GET_USERS: '/admin/api/users',
    CREATE_USER: '/admin/api/users',
    UPDATE_USER: '/admin/api/users',
    DELETE_USER: '/admin/api/users',
    BULK_UPLOAD: '/admin/api/users/bulk-upload',
    
    // Admin management endpoints
    GET_ADMINS: '/admin/api/admins',
    CREATE_ADMIN: '/admin/api/admins',
    UPDATE_ADMIN: '/admin/api/admins',
    DELETE_ADMIN: '/admin/api/admins',
    
    // Role management endpoints
    GET_ROLES: '/admin/api/roles',
    CREATE_ROLE: '/admin/api/roles',
    UPDATE_ROLE: '/admin/api/roles',
    DELETE_ROLE: '/admin/api/roles',
    
    // Quiz management endpoints
    GET_QUIZZES: '/admin/api/quizzes',
    CREATE_QUIZ: '/admin/api/admin/quiz',
    UPDATE_QUIZ: '/admin/api/admin/quiz',
    DELETE_QUIZ: '/admin/api/admin/quiz',
    CREATE_QUESTION: '/admin/api/quiz/{quizId}/questions',
    GET_QUIZ_QUESTIONS: '/admin/api/quiz/{quizId}/questions',
    UPDATE_QUESTION: '/admin/api/quiz/{quizId}/questions/{questionId}',
    DELETE_QUESTION: '/admin/api/quiz/{quizId}/questions/{questionId}',
    UPLOAD_QUIZ_DATA: '/admin/api/quizzes/upload',
    
    // Events endpoints
    GET_EVENTS: '/admin/api/events',
    CREATE_EVENT: '/admin/api/events',
    GET_EVENT: '/admin/api/events/{id}',
    UPDATE_EVENT: '/admin/api/events/{id}',
    DELETE_EVENT: '/admin/api/events/{id}',
    
    // Designations endpoints
    GET_DESIGNATIONS: '/admin/api/admin/designations',
    CREATE_DESIGNATION: '/admin/api/admin/designations',
    GET_DESIGNATION: '/admin/api/admin/designations/{id}',
    UPDATE_DESIGNATION: '/admin/api/admin/designations/{id}',
    DELETE_DESIGNATION: '/admin/api/admin/designations/{id}',
    
    // Results endpoints
    EXPORT_EXCEL: '/admin/api/results/{eventId}/export-excel',
    
    // Reviewer endpoints
    REVIEWER_EVENTS: '/admin/api/reviewer/events',
    REVIEWER_QUIZZES: '/admin/api/reviewer/events/{eventId}/quizzes',
    REVIEWER_USERS: '/admin/api/reviewer/quizzes/{quizId}/users',
    REVIEWER_ANSWERS: '/admin/api/reviewer/quizzes/{quizId}/users/{userId}/answers',
    REVIEWER_GRADE: '/admin/api/reviewer/answer-sheets/{answerSheetId}/grade',
    
    // Compiler endpoints
    COMPILER_EXECUTE: '/admin/api/user/compiler/execute',
    COMPILER_LANGUAGES: '/admin/api/user/compiler/languages'
  }
};

// API helper functions
const getApiUrl = (endpoint) => `${API_CONFIG.BASE_URL}${endpoint}`;

// Helper to format endpoints with parameters
const formatEndpoint = (endpoint, params = {}) => {
  let formattedEndpoint = endpoint;
  Object.keys(params).forEach(key => {
    formattedEndpoint = formattedEndpoint.replace(`{${key}}`, params[key]);
  });
  return formattedEndpoint;
};

// Legacy getAuthHeaders - kept for backward compatibility
// Use the role-based getAuthHeaders from apiClient instead
const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export { API_CONFIG, getApiUrl, getAuthHeaders, formatEndpoint };
